import { NgModule } from '@angular/core';

import {
  TableGroupHeaderComponent
} from "./records-table-view-components/table-group-header/table-group-header.component";
import {TableHeaderComponent} from "./records-table-view-components/table-header/table-header.component";
import {TableBodyComponent} from "./records-table-view-components/table-body/table-body.component";
import {TableFooterComponent} from "./records-table-view-components/table-footer/table-footer.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatCheckbox} from "@angular/material/checkbox";
import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {RecordsTableModule} from "../../records-table/records-table.module";
import {ScrollSyncDirective} from "../../../../shared/directives/scroll-sync.directive";
import {HiddenGroupComponent} from "./records-table-view-components/hidden-group/hidden-group.component";
import {TableNewRowComponent} from "./records-table-view-components/table-new-row/table-new-row.component";



@NgModule({
  declarations: [
    TableGroupHeaderComponent,
    TableHeaderComponent,
    TableBodyComponent,
    TableFooterComponent,
    HiddenGroupComponent,
    TableNewRowComponent
  ],
  imports: [

    MatTooltip,
    MatCheckbox,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    MatIcon,
    MatIconButton,
    RecordsTableModule,
    ScrollSyncDirective
  ],
  exports: [
    TableGroupHeaderComponent,
    TableHeaderComponent,
    TableBodyComponent,
    TableFooterComponent,
    HiddenGroupComponent,
    TableNewRowComponent
  ]
})
export class RecordsTableViewComponentsModule { }
